import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { IBusinessPlanType } from 'interfaces/businessPlan';

interface IBusinessPlanTypeChange {
  currentBusinessPlanType: IBusinessPlanType;
  newBusinessPlanType: IBusinessPlanType;
}

type AllowedBusinessPlanType = 'BANK' | 'LIGHT';

const BUSINESS_PLANS_ALLOWED_TYPE_CHANGE: AllowedBusinessPlanType[] = [
  BUSINESS_PLAN_TYPES.FOR_BANK,
  BUSINESS_PLAN_TYPES.FOR_INVESTORS,
] as AllowedBusinessPlanType[];

export const shouldBusinessPlanBeingCopied = ({
  currentBusinessPlanType,
  newBusinessPlanType,
}: IBusinessPlanTypeChange): boolean =>
  BUSINESS_PLANS_ALLOWED_TYPE_CHANGE.includes(currentBusinessPlanType as AllowedBusinessPlanType) &&
  BUSINESS_PLANS_ALLOWED_TYPE_CHANGE.includes(newBusinessPlanType as AllowedBusinessPlanType);
